import './libs/intersection-observer-polyfill';

window.addEventListener('load', () => {

    const slides = document.querySelectorAll('.presentation-slide');
    const slidesObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            console.log(entry.target.id, entry.isIntersecting, entry.intersectionRatio, entry.target);
            if (entry.isIntersecting) {
                let activeSlide = document.querySelector('.presentation-slide--active');
                if (activeSlide) {
                    activeSlide.classList.remove('presentation-slide--active');
                }
                entry.target.classList.add('presentation-slide--active');
                if (window.innerWidth > 1280) {
                    entry.target.querySelector('.presentation-slide__background').style.animationName = 'ken-burns';
                }
            }
        });
    }, {
        threshold: [0.3]
    });

    slides.forEach(slide => {
        slidesObserver.observe(slide);
    });

    Array.from(document.querySelectorAll('.js-scroll-down')).forEach(function (scrollDownLink) {
        scrollDownLink.addEventListener('click', function (e) {
            e.preventDefault();
            var parentSlide = scrollDownLink.closest('.presentation-slide');
            parentSlide.nextElementSibling.scrollIntoView({
                behavior: "smooth"
            });
        });
    });

});
